import React, {
  useState,
  useEffect,
} from 'react';
import { connect } from 'react-redux';
import {
  useRouteMatch,
  withRouter,
} from 'react-router-dom';
import { SpTab } from 'components/DesignKit';
import {
  Card,
  Menu,
  Spin,
} from 'antd';
import queryString from 'query-string';
import { lynxConnectActions, lynxTenantDetailActions } from 'store/actions';
import Invoices from './components/Invoices';

type Props = {
  // loading: boolean,
  test: boolean,
  validator: Boolean,
  location: {
    pathname: string,
    search: string,
  },
  history: {
    push: Function,
    replace: Function,
  };
  selectedAccount: Object,
  submitting: Boolean,
  lynxTenantDetails: Array,
  lynxConnectInvoices: Array,
  lynxConnectInvoicesTotalElements: Number,
  lynxConnectVendor: Array,
  lynxConnectLocations: Array,
  fetchInvoice: Function,
  fetchInvoiceMeta: Function,
  addNewInvoice: Function,
  fetchLynxTenantDetails: Function,
  lynxConnectLoading: Boolean,
  setAuditEvent: Function,
};

const LynxConnectInvoices = (props: Props) => {
  const {
    lynxTenantDetails,
    history,
    location,
    fetchLynxTenantDetails,
  } = props;

  // get the lynx tentant details
  useEffect(() => {
    fetchLynxTenantDetails();
  }, []);

  const [current, setCurrent] = useState('all');
  const { path } = useRouteMatch();

  const setMenu = (query) => {
    const parsed = queryString.parse(query);
    if (parsed['status.IN']) {
      const value = parsed['status.IN'];
      switch (value) {
        case 'ALL': {
          setCurrent('all');
          break;
        }
        case 'READY_TO_PROCESS': {
          setCurrent('readyToProcess');
          break;
        }
        case 'PROCESSED': {
          setCurrent('processed');
          break;
        }
        case 'ANALYZING': {
          setCurrent('analyzing');
          break;
        }
        case 'WAITING_FOR_APPROVAL': {
          setCurrent('waitingForApproval');
          break;
        }
        default:
          setCurrent('all');
      }
    }
  };

  useEffect(() => {
    if (location.search) {
      setMenu(location.search);
    } else {
      history.replace(`${path}?&status.IN=ALL`);
    }
  }, [location]);

  if (!Array.isArray(lynxTenantDetails)
    || lynxTenantDetails.length === 0
  ) {
    return <></>;
  }

  return (
    <Card bodyStyle={{ padding: 0 }}>
      <Spin
        spinning={props.lynxConnectLoading}
        tip="Please wait..."
        size="large"
        delay={300} // delay in ms to avoid flicker
      >
        <Menu
          onClick={e => setCurrent(e.key)}
          selectedKeys={[current]}
          mode="horizontal"
          style={{
            fontSize: '8px',
            backgroundColor: '#f5f5f5', // light grey
            borderTop: '1px solid #d9d9d9', // darker grey
            borderBottom: '1px solid #d9d9d9',
            // padding: '8px 0', // space above and below items
          }}
        >
          <SpTab
            to={`${path}?&status.IN=ALL`}
            selected={current === 'all'}
            style={{ padding: '0 20px' }}
          >
            All
          </SpTab>
          <SpTab
            to={`${path}?&status.IN=READY_TO_PROCESS`}
            selected={current === 'readyToProcess'}
            style={{ padding: '0 20px' }}
          >
            Ready to Process
          </SpTab>
          <SpTab
            to={`${path}?&status.IN=PROCESSED`}
            selected={current === 'processed'}
            style={{ padding: '0 20px' }}
          >
            Processed
          </SpTab>
          <SpTab
            to={`${path}?&status.IN=ANALYZING`}
            selected={current === 'analyzing'}
            style={{ padding: '0 20px' }}
          >
            Analyzing
          </SpTab>
          <SpTab
            to={`${path}?&status.IN=WAITING_FOR_APPROVAL`}
            selected={current === 'waitingForApproval'}
            style={{ padding: '0 20px' }}
          >
            Waiting For Approval
          </SpTab>
        </Menu>
        <Invoices {...props} />
      </Spin>
    </Card>
  );
};

const mapStateToProps = state => ({
  loading: state.loading.loading,
  validator: state.loading.validator,
  selectedAccount: state.account.selectedAccount,
  submitting: state.loading.submitting,
  test: state.account.test,
  lynxTenantDetails: state.lynxTenantDetails.lynxTenantDetails,
  lynxConnectInvoices: state.lynxConnect.invoices.content,
  lynxConnectInvoicesTotalElements: state.lynxConnect.invoices.totalElements,
  lynxConnectVendor: state.lynxConnect.invoices.meta.vendors,
  lynxConnectLocations: state.lynxConnect.invoices.meta.locations,
  lynxConnectAddNewInvoiceStatus: state.lynxConnect.invoices.addNewInvoiceStatus,
  lynxConnectLoading: state.lynxConnect.loading,
});

const mapDispatchToProps = dispatch => ({
  fetchInvoice: param => dispatch(lynxConnectActions.fetchInvoices({
    payload: param,
  })),
  fetchInvoiceMeta: param => dispatch(lynxConnectActions.fetchInvoiceMeta({
    payload: param,
  })),
  addNewInvoice: param => dispatch(lynxConnectActions.addNewInvoice({
    payload: param,
  })),
  resetAddNewInvoiceStatus: param => dispatch(lynxConnectActions.setAddNewInvoiceStatus({
    payload: param,
  })),
  resetInvoices: param => dispatch(lynxConnectActions.resetInvoices({
    payload: param,
  })),
  fetchLynxTenantDetails: param => dispatch(lynxTenantDetailActions.fetchLynxTenantDetails({
    payload: param,
  })),
  setAuditEvent: param => dispatch(lynxConnectActions.setAuditEvent({
    payload: param,
  })),
});

// $FlowFixMe
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LynxConnectInvoices));
